import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng-fe/ui_pc_ad';
import Subject from './subject';
import Market from './market';
import Courier from './courier/';
import PlayItem from './playItem/';
import DayStockTit from './dayStockTit';
import DayStock from './dayStock/';
import RightSideTitle from '../../../components/rightSideTitle';

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.col_R}>
                <div className={styles.box}>
                    <Chip
                        id="20055"
                        type="struct"
                        title="热点专题标题"
                        groupName="正文"
                        content={content.subjectTitle}
                        position="relative">
                        <RightSideTitle />
                    </Chip>
                    <Subject content={content.subject} />
                </div>
                <div className="clear" />
                <Chip
                    id="20056"
                    type="struct"
                    title="投教学堂标题"
                    groupName="正文"
                    content={content.marketTitle}
                    position="relative">
                    <RightSideTitle />
                </Chip>
                <NoSSR>
                    <Chip
                        id="10080"
                        type="static"
                        title="投教学堂"
                        groupName="正文"
                        content={content.market}
                        position="relative">
                        <Market />
                    </Chip>
                </NoSSR>
                {/* 
                <Courier content={content.courier} />
                 */}
                <Chip
                    id="20058"
                    type="struct"
                    title="视频播放项"
                    groupName="正文"
                    content={content.playItem}
                    position="relative">
                    <PlayItem />
                </Chip>
                <div className={styles.ad0}>
                    <NoSSR onSSR={<div className={styles.ad_box0} />}>
                        <Ad content={content.rightSideAd0} styleName={styles.ad_box0} />
                    </NoSSR>
                </div>
                <div className={styles.ad1}>
                    <NoSSR onSSR={<div className={styles.ad_box1} />}>
                        <Ad content={content.rightSideAd1} styleName={styles.ad_box1} />
                    </NoSSR>
                </div>
                <div className={styles.box}>
                    <div className={styles.dayStock}>
                        <Chip
                            id="170098"
                            type="struct"
                            title="每日论股标题"
                            groupName="正文"
                            content={content.dayStockTitle}
                            position="relative">
                            <DayStockTit />
                        </Chip>
                        <Chip
                            id="20040"
                            type="recommend"
                            title="每日论股"
                            groupName="正文"
                            content={content.dayStock}
                            translate="handleDayStockData">
                            <DayStock />
                        </Chip>
                    </div>
                </div>
            </div>
        );
    }
}

export default RightContent;
